import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { PageComponent } from "@components/page/page.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ProduktionsomradeDTO } from "~app/common/models/produktionsomrade/ProduktionsomradeDTO";
import { ProduktionsomradeDetailDialogService } from "./produktionsomrade-detail/produktionsomrade-detail-dialog.service";
import { ProduktionsomradeService } from "./produktionsomrade.service";
import { ProduktionsomradeTexts } from "./produktionsomrade.texts";

@Component({
    selector: "rask-produktionsomrade",
    templateUrl: "./produktionsomrade.component.html",
    styleUrls: ["./produktionsomrade.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ListComponent,
        ListColumnDirective
    ]
})
export class ProduktionsomradeComponent implements OnInit {
    produktionsomraden: ProduktionsomradeDTO[];
    texts = ProduktionsomradeTexts.texts;

    private readonly busyService = inject(BusyService);
    private readonly produktionsomradeDialogService = inject(ProduktionsomradeDetailDialogService);
    private readonly produktionsomradeService = inject(ProduktionsomradeService);

    async ngOnInit(): Promise<void> {
        this.busyService.addWork(this.produktionsomradeService.getAllProduktionsomraden())
            .subscribe(produktionsomraden => {
                this.produktionsomraden = produktionsomraden;
            });
    }

    openDetail(event: Event,id: number) {
        event.preventDefault();
        this.produktionsomradeDialogService.produktionsomradeDetailModal(id)
            .subscribe();
    }
}
